import { useEffect, useState } from 'react'

function detectGoogleTranslate(): boolean {
	if (typeof document === 'undefined') return false
	try {
		// Common markers injected by Google Translate or browser translation UIs
		if (document.getElementById('google_translate_element')) return true
		// goog- prefixed elements (widget + browser translations)
		if (document.querySelector('[class*="goog-"]')) return true
		if (document.querySelector('select.goog-te-combo')) return true
		if (document.querySelector('.goog-te-gadget')) return true

		// banner/menu/iframe injected by Google Translate or browser translation
		if (document.getElementById('goog-te-banner-frame')) return true
		if (document.querySelector('iframe[src*="translate.google"]')) return true
		if (document.querySelector('iframe[src*="translate.googleusercontent.com"]')) return true
		if (document.querySelector('iframe[src*="translate.goog"]')) return true
		if (document.querySelector('.goog-te-menu-value')) return true

		// Some translation UIs add attributes or classes to the root
		const htmlClass = document.documentElement.className || ''
		if (/translated|translate|goog-/.test(htmlClass)) return true
		const translatedAttr = document.documentElement.getAttribute('translated')
		if (translatedAttr === '1' || translatedAttr === 'true') return true

		// Heuristic: many translation widgets inject `lang` attributes on spans around translated text.
		// Sample a subset of elements and check how many have a non-empty `lang` attribute.
		try {
			const sample = Array.from(document.querySelectorAll('body *:not(script):not(style)')).slice(
				0,
				250
			)
			if (sample.length > 0) {
				const withLang = sample.filter(
					(el) =>
						el.hasAttribute &&
						el.hasAttribute('lang') &&
						(el.getAttribute('lang') || '').trim() !== ''
				).length
				// If a notable fraction of sampled elements have a lang attribute, likely a translation wrapper was applied.
				if (withLang / sample.length > 0.15) return true
			}
		} catch (err) {
			void err
		}

		// Other possible markers: attributes like data-gt, data-google-translate, or elements with classnames containing 'translated-ltr'
		if (document.querySelector('[data-gt], [data-google], [data-google-translate]')) return true
		if (document.querySelector('[class*="translated-ltr"], [class*="translated-rtl"]')) return true
	} catch (err) {
		void err
	}
	return false
}

export default function TranslateWarning() {
	const [visible, setVisible] = useState(false)

	useEffect(() => {
		if (typeof window === 'undefined' || typeof document === 'undefined') return

		// Initial detection
		if (detectGoogleTranslate()) {
			setVisible(true)
		}

		// Observe the DOM in case translate UI is injected after load
		const observer = new MutationObserver(() => {
			if (detectGoogleTranslate()) setVisible(true)
		})
		observer.observe(document.body, { childList: true, subtree: true })

		return () => observer.disconnect()
	}, [])

	if (!visible) return null

	return (
		<div className="text-small mb-4 rounded-md bg-red-700 p-3 text-center font-medium text-white shadow-md">
			<span>⚠️ Please disable browser translation to avoid app crashes.</span>
		</div>
	)
}
